import React from "react";
import Axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import Constants from "./constant";

let gatewayPostAuthNew = async (props, input) => {
  var config = {
    method: "post",
    url: Constants.serviceRoot,
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      "Content-Type": "application/json",
    },

    data: {
      Activity: input.Activity,
      Input: input.Input,
    },
  };
  return await Axios(config)
    .then(function (response) {
      if (Object.entries(input).length === 0) {
        return response.data.d;
      } else {
        return JSON.parse(response.data.d["Result"]);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const GatewayGet = async (props, input) => {
  return await gatewayPostAuthNew(props, input);
};

export default GatewayGet;
